import { createSlice } from '@reduxjs/toolkit';
import { isUndefined } from 'lodash';
import { authApi } from '../services/authApi';

const initialState = {
  isLoggedIn: false,
  statusCode: null,
  user: undefined,
  // this is used when feature login as user is used for switching between users
  originalUser: undefined,
  accessToken: undefined,
  selfLogout: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setTokenExpiry(state, { payload }) {
      if (!state.isLoggedIn) {
        return;
      }
    },

    logout(state, { payload }) {
      return { ...initialState, selfLogout: payload ?? true };
    },

    setSelfLogout(state, { payload }) {
      state.selfLogout = payload;
    },
  },

  extraReducers: (builder) => {
    builder
      // when login request is fulfilled (successful), then update state
      .addMatcher(
        authApi.endpoints.login.matchFulfilled,
        (state, { payload }) => {
          return {
            ...state,
            isLoggedIn: true,
            user: payload.user,
            accessToken: payload.access_token,
          };
        },
      )

      .addMatcher(
        authApi.endpoints.impersonate.matchFulfilled,
        (state, { payload }) => {
          return {
            ...state,
            user: payload.user,
            accessToken: payload.access_token,
            originalUser: state.user,
          };
        },
      )

      .addMatcher(
        authApi.endpoints.leaveImpersonation.matchFulfilled,
        (state, { payload }) => {
          return {
            ...state,
            user: payload.user,
            accessToken: payload.accessToken,
            originalUser: undefined,
          };
        },
      )

      .addMatcher(
        authApi.endpoints.refresh.matchFulfilled,
        (state, { payload }) => {
          return {
            ...state,
            accessToken: payload.access_token,
            user: payload.user,
          };
        },
      )

      .addMatcher(authApi.endpoints.refresh.matchRejected, (_) => {
        return {
          ...initialState,
        };
      });
  },
});

export default authSlice.reducer;

export const { login, setTokenExpiry, logout, setSelfLogout } =
  authSlice.actions;
